export default "__VITE_ASSET__Bhs2Y2gP__"